import { Rect } from '../../../../foundation/geometry/rect';
import { RectFuncs } from '../../../../foundation/geometry/rect.funcs';
import { PopupPosition } from './popup-position';

function getPosition({ triggerRect, popupRect, boundaryRect, position }: { triggerRect: Rect; popupRect: Rect; boundaryRect: Rect; position: PopupPosition }) {
  let [x1, x2] = (() => {
    let x1 = 0;
    if (position.x.start === 'right') {
      x1 = RectFuncs.getMaxX(triggerRect);
    } else {
      x1 = RectFuncs.getMinX(triggerRect);
    }

    if (position.x.direction === 'left') {
      x1 -= position.x.gap ?? 0;
    } else if (position.x.direction === 'right') {
      x1 += position.x.gap ?? 0;
    }

    let x2 = 0;
    if (position.x.direction === 'left') {
      x2 = x1 - RectFuncs.getSizeX(popupRect);
    } else {
      x2 = x1 + RectFuncs.getSizeX(popupRect);
    }

    return [x1, x2];
  })();

  let [y1, y2] = (() => {
    let y1 = 0;
    if (position.y.start === 'bottom') {
      y1 = RectFuncs.getMaxY(triggerRect);
    } else {
      y1 = RectFuncs.getMinY(triggerRect);
    }

    if (position.y.direction === 'top') {
      y1 -= position.y.gap ?? 0;
    } else if (position.y.direction === 'bottom') {
      y1 += position.y.gap ?? 0;
    }

    let y2 = 0;
    if (position.y.direction === 'top') {
      y2 = y1 - RectFuncs.getSizeY(popupRect);
    } else {
      y2 = y1 + RectFuncs.getSizeY(popupRect);
    }

    return [y1, y2];
  })();

  return RectFuncs.from({ x: Math.min(x1, x2), y: Math.min(y1, y2), width: Math.abs(x2 - x1), height: Math.abs(y2 - y1) });
}

function getBestPosition({
  triggerRect,
  popupRect,
  boundaryRect,
  positions,
}: {
  triggerRect: Rect;
  popupRect: Rect;
  boundaryRect: Rect;
  positions: PopupPosition[];
}) {
  const best = positions
    .map((position) => {
      const rect = getPosition({ triggerRect, popupRect, boundaryRect, position });
      return rect;
    })
    .find((rect) => {
      return RectFuncs.isInside({ rect, inside: boundaryRect });
    });

  return best;
}

export const PopupPositionFuncs = {
  getBestPosition,
};
